import Finance from '~/@lib/utils/finance.utils'

export function calculateAverageCompoundedYields(
  yieldPerAnnum: number,
  months: number
) {
  const compoundedMonthlyYield = yieldPerAnnum / 12 / 100
  const years = months / 12
  const compoundedYieldPerAnnumAverageFirstMonth =
    (Math.pow(1 + compoundedMonthlyYield, 12) - 1) * 100
  const compoundedYieldPerAnnumAverageTotal =
    ((Math.pow(1 + compoundedMonthlyYield, months) - 1) / years) * 100

  return {
    compoundedYieldPerAnnumAverageFirstMonth,
    compoundedYieldPerAnnumAverageTotal,
  }
}

export function calculateAverageCompoundedYield(
  yieldPerAnnum: number,
  months: number
) {
  const compoundedMonthlyYield = yieldPerAnnum / 12 / 100
  const years = months / 12
  return ((Math.pow(1 + compoundedMonthlyYield, months) - 1) / years) * 100
}

export const calculateTotalCompoundedYield = (
  yieldPerAnnum: number,
  period: number,
  extendPeriod: number | null
): number => {
  const totalPeriod = period + (extendPeriod || 0)
  const compoundedMonthlyYield = 1 + yieldPerAnnum / 12 / 100
  const totalCompoundedYield = Math.pow(compoundedMonthlyYield, totalPeriod) - 1
  return Finance.round(totalCompoundedYield * 100)
}
